<template>
  <div class="fan fan-component">
    <div class="upesign">
      <!-- 有签名时显示图片和清除按钮 -->
      <template v-if="fileList.length > 0">
        <img
          style="width: 40px; cursor: pointer"
          :src="value"
          @click="bindImgsPreview"
        />
        <a-button
          v-if="!sudisabled"
          size="small"
          type="text"
          style="color: #f5222d; margin-left: 10px"
          @click="handleClearSignature"
        >清除</a-button>
      </template>
      <!-- 无签名且未禁用时显示签名按钮 -->
      <a-button
        v-else-if="!sudisabled"
        size="small"
        type="primary"
        @click="bindOpenEsign"
      >签名</a-button>
    </div>

    <!-- 图片预览弹窗 -->
    <a-modal :visible="isPreviewOpen" :footer="false" unmount-on-close @cancel="closePreview">
      <img style="width: 100%" :src="previewImg" />
    </a-modal>

    <!-- 签名弹窗 -->
    <a-modal title="请完成签名" :visible="isSignOpen" unmount-on-close @cancel="closeSign">
      <vue-esign
        ref="esign"
        :width="600"
        :height="200"
        :lineWidth="esign.lineWidth"
        :lineColor="esign.lineColor"
        :bgColor.sync="esign.bgColor"
      />
      <template #footer>
        <a-button @click="handleReset">清空面板</a-button>
        <a-button type="primary" @click="handleGenerate">确认签名</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
  import vueEsign from 'vue-esign'
  const env = require('../../../env/index')

  export default {
    name: 'FEsign',
    components: { vueEsign },
    props: {
      name: String,
      value: { type: String, default: '' },
      sudisabled: { type: Boolean, default: false }
    },
    data() {
      return {
        upUrl: env.UPLOAD,
        fileList: [],
        previewImg: '',
        isPreviewOpen: false,
        isSignOpen: false,
        esign: {
          lineWidth: 6,
          lineColor: '#000000',
          bgColor: ''
        }
      }
    },
    created() {
      if (this.value) {
        this.fileList = [{ uid: Date.now(), name: '签名', thumbUrl: this.value, status: 'done' }]
      }
    },
    methods: {
      bindOpenEsign() {
        if (this.sudisabled) return
        if (this.$refs.esign) this.$refs.esign.reset()
        this.isSignOpen = true
      },
      bindImgsPreview() {
        this.previewImg = this.value
        this.isPreviewOpen = true
      },
      closePreview() {
        this.previewImg = ''
        this.isPreviewOpen = false
      },
      closeSign() {
        this.isSignOpen = false
      },
      handleReset() {
        if (this.$refs.esign) this.$refs.esign.reset()
      },
      handleClearSignature() {
        this.fileList = []
        this.$emit('change', this.name, '')
        if (this.$refs.esign) this.$refs.esign.reset()
      },
      handleGenerate() {
        this.$refs.esign.generate().then(base64Str => {
          const bytes = window.atob(base64Str.split(',')[1])
          const ab = new ArrayBuffer(bytes.length)
          const ia = new Uint8Array(ab)
          for (let i = 0; i < bytes.length; i++) ia[i] = bytes.charCodeAt(i)
          const file = new File([ab], 'sign_' + Date.now() + '.jpg', { type: 'image/jpg' })
          this.$fan.api.upload(this.upUrl, file).then(res => {
            if (res && res.data) {
              const url = res.data
              this.fileList = [{ uid: Date.now(), name: url, thumbUrl: url, status: 'done' }]
              this.$emit('change', this.name, url)
              this.isSignOpen = false
            }
          })
        }).catch(() => {})
      }
    }
  }
</script>
